var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticStyle:{"color":"#d3d3d3","font-size":"40px","margin":"10px"}},[_vm._v("信息尚未完善")])])}]

export { render, staticRenderFns }